import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";

import {elevation} from "@pg-design/elevation";
import {borderRadius, calculateRemSize as crs, p} from "@pg-design/helpers-css-strings";
import {BrandMedalIcon, BrandRankingIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

import {useResponsiveLinkTarget} from "../../../../hooks/use_responsive_link_target";
import {useOfferLink} from "../../../../offer/detail/hooks/use_offer_link";
import {IOfferDetail} from "../../../../offer/types/IOfferDetail";
import {getThumbnailLink} from "../../../../utils/get_thumbnail_link";
import {rankingBigViewBreakpoint} from "../../../constants/ranking_big_view_breakpoint";
import {RankingOfferData} from "../../RankingOfferData";

interface IProps {
    place: number;
    offer: Pick<IOfferDetail, "name" | "main_image" | "main_image_url" | "street_name" | "street_number" | "region" | "vendor" | "slug" | "id" | "groups">;
    onCardClick?: () => void;
}

export function OfferRankingCard(props: IProps) {
    const {place, offer} = props;
    const {main_image, name} = offer;

    const isFirst = place === 1;

    const offerLink = useOfferLink(offer);
    const target = useResponsiveLinkTarget();

    return (
        <RankingCardWrap isFirst={isFirst} onClick={props.onCardClick}>
            <RankingCard isFirst={isFirst}>
                <span css={cardTitle}>
                    {isFirst ? (
                        <BrandRankingIcon wrapperSize="4.8" wrapperColor="transparent" size="4.8" />
                    ) : (
                        <BrandMedalIcon wrapperSize="4.8" wrapperColor="transparent" size="4.8" />
                    )}
                    <Text as="p" variant="headline_6">
                        {place} miejsce
                    </Text>
                </span>
                <a href={offerLink} target={target}>
                    {isFirst ? (
                        <Image width="360" height="360" alt={name} src={getThumbnailLink(offer.main_image_url, 440, 440) ?? main_image.m_img_440x440} />
                    ) : (
                        <Image width="360" height="280" alt={name} src={getThumbnailLink(offer.main_image_url, 440, 440) ?? main_image.m_img_440x440} />
                    )}
                </a>
                <div css={cardContentStyle}>
                    <RankingOfferData offer={offer} />
                </div>
            </RankingCard>
        </RankingCardWrap>
    );
}

// Styles
const RankingCardWrap = styled.li<{isFirst: boolean}>`
    ${({isFirst}) => css`
        position: relative;
        ${isFirst
            ? css`
                  order: 0;
              `
            : css`
                  order: 1;
              `};

        @media screen and (min-width: ${rankingBigViewBreakpoint}) {
            order: initial;
            ${isFirst
                ? css`
                      grid-row-start: 1;
                      grid-row-end: span 3;
                  `
                : css`
                      height: 100%;
                      grid-row-start: 2;
                      grid-row-end: 2;
                  `}
        }
    `}
`;

const RankingCard = styled.div<{isFirst: boolean}>`
    ${({isFirst}) => css`
        display: flex;
        flex-direction: column;
        position: relative;
        max-width: 360px;
        background: white;
        overflow: visible;
        ${cardElevation(isFirst)};
        ${borderRadius(2)};

        @media screen and (min-width: ${rankingBigViewBreakpoint}) {
            height: 100%;
        }
    `}
`;

const cardTitle = (theme: Theme) => css`
    display: flex;
    align-items: center;
    gap: ${crs(1)};
    ${p(1.5)};
    justify-content: center;
    background: ${theme.colors.primary};
    ${borderRadius(2, 2, 0, 0)}
`;

const cardContentStyle = css`
    ${p(2)};
    gap: ${crs(2)};
    display: flex;
    flex-direction: column;
    flex: 1;
    ${borderRadius(0, 0, 2, 2)};
`;

const cardElevation = (isFirst: boolean) => (isFirst ? elevation(4) : elevation(2));
import {css, Theme} from "@emotion/react";
import styled from "@emotion/styled";

import {elevation} from "@pg-design/elevation";
import {borderRadius, calculateRemSize as crs, p} from "@pg-design/helpers-css-strings";
import {BrandMedalIcon, BrandRankingIcon} from "@pg-design/icons-module";
import {Image} from "@pg-design/image-module";
import {Text} from "@pg-design/text-module";

import {useResponsiveLinkTarget} from "../../../../hooks/use_responsive_link_target";
import {useOfferLink} from "../../../../offer/detail/hooks/use_offer_link";
import {IOfferDetail} from "../../../../offer/types/IOfferDetail";
import {getThumbnailLink} from "../../../../utils/get_thumbnail_link";
import {rankingBigViewBreakpoint} from "../../../constants/ranking_big_view_breakpoint";
import {RankingOfferData} from "../../RankingOfferData";

interface IProps {
    place: number;
    offer: Pick<IOfferDetail, "name" | "main_image" | "main_image_url" | "street_name" | "street_number" | "region" | "vendor" | "slug" | "id" | "groups">;
    onCardClick?: () => void;
}

export function OfferRankingCard(props: IProps) {
    const {place, offer} = props;
    const {main_image, name} = offer;

    const isFirst = place === 1;

    const offerLink = useOfferLink(offer);
    const target = useResponsiveLinkTarget();

    return (
        <RankingCardWrap isFirst={isFirst} onClick={props.onCardClick}>
            <RankingCard isFirst={isFirst}>
                <span css={cardTitle}>
                    {isFirst ? (
                        <BrandRankingIcon wrapperSize="4.8" wrapperColor="transparent" size="4.8" />
                    ) : (
                        <BrandMedalIcon wrapperSize="4.8" wrapperColor="transparent" size="4.8" />
                    )}
                    <Text as="p" variant="headline_6">
                        {place} miejsce
                    </Text>
                </span>
                <a href={offerLink} target={target}>
                    {isFirst ? (
                        <Image width="360" height="360" alt={name} src={getThumbnailLink(offer.main_image_url, 440, 440) ?? main_image.m_img_440x440} />
                    ) : (
                        <Image width="360" height="280" alt={name} src={getThumbnailLink(offer.main_image_url, 440, 440) ?? main_image.m_img_440x440} />
                    )}
                </a>
                <div css={cardContentStyle}>
                    <RankingOfferData offer={offer} />
                </div>
            </RankingCard>
        </RankingCardWrap>
    );
}

// Styles
const RankingCardWrap = styled.li<{isFirst: boolean}>`
    ${({isFirst}) => css`
        position: relative;
        ${isFirst
            ? css`
                  order: 0;
              `
            : css`
                  order: 1;
              `};

        @media screen and (min-width: ${rankingBigViewBreakpoint}) {
            order: initial;
            ${isFirst
                ? css`
                      grid-row-start: 1;
                      grid-row-end: span 3;
                  `
                : css`
                      height: 100%;
                      grid-row-start: 2;
                      grid-row-end: 2;
                  `}
        }
    `}
`;

const RankingCard = styled.div<{isFirst: boolean}>`
    ${({isFirst}) => css`
        display: flex;
        flex-direction: column;
        position: relative;
        max-width: 360px;
        background: white;
        overflow: visible;
        ${cardElevation(isFirst)};
        ${borderRadius(2)};

        @media screen and (min-width: ${rankingBigViewBreakpoint}) {
            height: 100%;
        }
    `}
`;

const cardTitle = (theme: Theme) => css`
    display: flex;
    align-items: center;
    gap: ${crs(1)};
    ${p(1.5)};
    justify-content: center;
    background: ${theme.colors.primary};
    ${borderRadius(2, 2, 0, 0)}
`;

const cardContentStyle = css`
    ${p(2)};
    gap: ${crs(2)};
    display: flex;
    flex-direction: column;
    flex: 1;
    ${borderRadius(0, 0, 2, 2)};
`;

const cardElevation = (isFirst: boolean) => (isFirst ? elevation(4) : elevation(2));
